<div class="col-md-12" style="margin-left: -125px">
    <div class="tab-pane" role="tabpanel" id="formulario27">
        <fieldset id="agregar_formulario27" class="">
            <div class="container" id="center_div">
                <div class="row">
                    <div class="col-md-12">
                        <div id='page1' class="contenedorFormulario print-wrap page1">
                            <div>
                                <span style="float: right; clear: right;">(S.R.D.E. - 5.2.5./5.2.6.)</span> Formulario 2.7
                                <span style="float: right; clear: right;">1/3</span>
                            </div>
                            <h1><strong>SOLICITUD DE RECEPCI&Oacute;N DEFINITIVA DE OBRAS DE EDIFICACI&Oacute;N</strong></h1>
                            <br />
                            <div class="col-md-1"></div>
                            <div class="col-md-10">
                                <table class="title">
                                    <tr>

                                        <td class="col-md-3">
                                            <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].obra" name="obra" id="obra" />
                                            <label class="titleBox" for="optradio"> OBRA NUEVA</label>
                                        </td>
                                        <td class="col-md-4 letraChica">
                                            <label class="titleBox" for="optradio">LOTEO DFL CON INSTRUCCION SIMULTANEA</label>
                                        </td>
                                        <td class="col-md-1 letraChica">
                                            <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].loteo_dfl == 'SI'" name="loteo_dfl" id="loteo_dfl" />
                                            <label class="titleBox" for="loteo_dfl"> SI</label>
                                        </td>
                                        <td class="col-md-1 letraChica">
                                            <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].loteo_dfl == 'NO'" name="loteo_dfl" id="loteo_dfl" />
                                            <label class="titleBox" for="loteo_dfl"> NO</label>
                                        </td>
                                        <td class="col-md-3">&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td class="col-md-3"></td>
                                        <td class="col-md-4 letraChica">
                                            <label class="titleBox" for="optradio">LOTEO DFL CON CONSTRUCCION SIMULTANEA</label>
                                        </td>
                                        <td class="col-md-1 letraChica">
                                            <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].loteo_const == 'SI'" name="loteo_const" id="loteo_const" />
                                            <label class="titleBox" for="loteo_const"> SI</label>
                                        </td>
                                        <td class="col-md-1 letraChica">
                                            <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].loteo_const == 'NO'" name="loteo_const" id="loteo_const" />
                                            <label class="titleBox" for="loteo_const"> NO</label>
                                        </td>
                                        <td class="col-md-3">&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="col-md-1"></div>
                            <table>
                                <tr>
                                    <td class="col-md-3">
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].ampliacion" name="optradio2" id="optradio" />
                                        <label class="titleBox" for="optradio"> AMPLIACI&Oacute;N MAYOR A 100 M2</label>
                                    </td>
                                    <td class="col-md-3">
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].alteracion" name="optradio3" id="optradio" />
                                        <label class="titleBox" for="optradio"> ALTERACI&Oacute;N</label>
                                    </td>
                                    <td class="col-md-3">
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].reparacion" name="optradio1" id="optradio" />
                                        <label class="titleBox" for="optradio"> REPARACI&Oacute;N</label>
                                    </td>
                                    <td class="col-md-3">
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].reconstruccion" name="optradio3" id="optradio" />
                                        <label class="titleBox" for="optradio"> RECONSTRUCCI&Oacute;N</label>
                                    </td>
                                </tr>
                            </table>
                            <br />
                            <div class="row">
                                <div class="col-md-4">
                                    &nbsp;
                                </div>
                                <div class="col-md-4">
                                    <h2 class="infObligatorios">
                                        <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                    <h2 class="infObligatorios"> {{region}} </h2>
                                    <table class="tablaConBorde">
                                        <tr>
                                            <td>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'urbano'" [checked]="propiedad[0].ubicacion == 'URBANO'" />
                                                <label for="tpradio">URBANO</label>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'rural'" [checked]="propiedad[0].ubicacion == 'RURAL'" />
                                                <label for="tpradio">RURAL</label>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-md-4">
                                    <table style="float: right; clear: right; width: 140px;" class="tablaConBorde table">
                                        <tbody>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    N&Uacute;MERO SOLICITUD
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">
                                                    <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    Fecha de Ingreso
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td class="letraChica">
                                                    * A LLENAR POR LA D.O.M
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                            <br>
                            <div>
                                <table style="width: 100%;" class="tablaConBorde table">

                                    <tr class="rd_tipo">
                                        <td class="fondoResaltado izquierda" style="width: 20%">
                                            TIPO SOLICITUD:
                                        </td>
                                        <td><input disabled class="form-check-inline" type="checkbox" name="tipo_recepcion" id="tipo_recepcion" [checked]="tipo_recepcion[0].option == '1'" align="left" /></td>
                                        <td class="fondoResaltado">
                                            RECEPCION DEFINITIVA PARCIAL
                                        </td>
                                        <td><input disabled class="form-check-inline" type="checkbox" name="tipo_recepcion" id="tipo_recepcion" [checked]="tipo_recepcion[0].option == '2'" align="left" /></td>
                                        <td class="fondoResaltado">
                                            RECEPCION DEFINITIVA TOTAL
                                        </td>

                                    </tr>

                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span> 1.- DIRECCI&Oacute;N DE LA PROPIEDAD</span>
                                    <span class="help-block"></span>
                                </div>
                                <table style="width: 100%" border="0" class="tablaConBorde table">
                                    <tr class="fondoResaltado">
                                        <td style="width: 57%" colspan="3">
                                            CALLE O CAMINO
                                        </td>
                                        <td style="width: 24%">
                                            N&Uacute;MERO
                                        </td>
                                        <td style="width: 19%">
                                            ROL SII
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="propiedad[0].calle" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="propiedad[0].calle_num" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rol" name="rol" type="text" [(ngModel)]="propiedad[0].rol" />
                                        </td>

                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td style="width: 11%">
                                            MANZANA
                                        </td>
                                        <td style="width: 10%">
                                            LOTE
                                        </td>
                                        <td style="width: 61%" colspan="2">
                                            LOTEO O LOCALIDAD
                                        </td>
                                        <td style="width: 18%">
                                            PLANO DE LOTEO N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="manzana" name="manzana" type="text" [(ngModel)]="propiedad[0].manzana" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" name="lote" id="lote" type="text" [(ngModel)]="propiedad[0].lote" />
                                        </td>
                                        <td colspan="2">
                                            <input disabled class="form-control" id="localidad" name="localidad" type="text" [(ngModel)]="propiedad[0].localidad" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="loteo_numero" name="loteo_numero" type="text" [(ngModel)]="propiedad[0].loteo_numero" />
                                        </td>
                                    </tr>
                                </table>

                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>2.- DATOS DEL PROPIETARIO</span>
                                    <span class="help-block"></span>
                                </div>
                                <div>
                                    <span>2.1 DATOS DEL PROPIETARIO</span>
                                </div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left">
                                            NOMBRE DEL PROPIETARIO
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                        <td>
                                            FIRMA DEL PROPIETARIO
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <input disabled class="form-control" readonly id="nombre_prop" name="nombre_prop" type="text" [(ngModel)]="propietarios[0].nombre" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rut_prop" name="rut_prop" type="text" [(ngModel)]="propietarios[0].rut" />
                                        </td>
                                        <td rowspan="7">

                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left">
                                            REPRESENTANTE LEGAL
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><input disabled class="form-control" readonly id="nombre_rep" name="nombre_rep" type="text" [(ngModel)]="propietarios[0].nombre" /></td>
                                        <td><input disabled class="form-control" id="rut_rep" name="rut_rep" type="text" [(ngModel)]="propietarios[0].rut" /></td>
                                    </tr>

                                    <tr class="fondoResaltado">
                                        <td style="width: 25%" align="left">
                                            DIRECCI&Oacute;N / CALLE / PASAJE
                                        </td>
                                        <td style="width: 25%">
                                            N°
                                        </td>
                                        <td style="width: 25%">
                                            COMUNA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="propietarios[0].direccion" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="propietarios[0].direccion_num" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="propietarios[0].comuna" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado" align="left">
                                        <td>
                                            E-MAIL
                                        </td>
                                        <td>
                                            TEL&Eacute;FONO
                                        </td>
                                        <td>
                                            FAX
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="email_prop" name="email_prop" type="email" [(ngModel)]="propietarios[0].mail" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="tel_prop" name="tel_prop" type="text" [(ngModel)]="propietarios[0].fono" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fax_prop" name="fax_prop" type="text" [(ngModel)]="propietarios[0].fax" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado tablaConBordeExterno table">
                                        <td colspan="4" align="left">
                                            PERSONERIA DEL REPRESENTANTE LEGAL
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            SE ACREDITA MEDIANTE
                                        </td>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="acredita" name="acredita" type="text" [(ngModel)]="permiso_notariado[0].acreditacion" />
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            DE FECHA
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fecha_acr" name="fecha_acr" type="text" [(ngModel)]="permiso_notariado[0].fecha" />
                                        </td>
                                        <td>
                                            Y REDUCIDA A ESCRITURA PUBLICA CON FECHA
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fecha_esc" name="fecha_esc" type="text" [(ngModel)]="permiso_notariado[0].escritura" />
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            ANTE EL NOTARIO SR(A)
                                        </td>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="notario" name="notario" type="text" [(ngModel)]="permiso_notariado[0].notario" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>2.2- ARQUITECTO</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left"><span>
                                                NOMBRE O RAZON SOCIAL DE LA EMPRESA</span><span class="letraChica">(cuando corresponda)</span>
                                        </td>
                                        <td style="width: 20%">
                                            R.U.T.
                                        </td>
                                        <td style="width: 15%">
                                            FIRMA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="width: 65%">
                                            <input disabled class="form-control" readonly id="nombre_emp" name="nombre_emp" type="text" [(ngModel)]="arquitectos[0].nombre" />
                                        </td>
                                        <td style="width: 20%">
                                            <input disabled class="form-control" id="rut_emp" name="rut_emp" type="text" [(ngModel)]="arquitectos[0].rut" />
                                        </td>
                                        <td rowspan="5" style="width: 15%"></td>

                                    </tr>
                                    <tr class=" fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left">
                                            NOMBRE ARQUITECTO RESPONSABLE
                                        </td>
                                        <td style="width: 20%">
                                            R.U.T.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="width: 60%"><input disabled class="form-control" readonly id="nombre_arq" name="nombre_arq" type="text" [(ngModel)]="arquitectos[0].nombre" /></td>
                                        <td style="width: 20%"><input disabled class="form-control" id="rut_arq" name="rut_arq" type="text" [(ngModel)]="arquitectos[0].rut" /></td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda" style="width: 30%">
                                            DIRECCI&Oacute;N / CALLE / PASAJE
                                        </td>
                                        <td style="width: 30%" class="fondoResaltado">
                                            N°
                                        </td>
                                        <td style="width: 20%" class="fondoResaltado">
                                            COMUNA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 30%">
                                            <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="arquitectos[0].direccion" />
                                        </td>
                                        <td style="width: 30%">
                                            <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="arquitectos[0].direccion_num" />
                                        </td>
                                        <td style="width: 20%">
                                            <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="arquitectos[0].comuna" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda" style="width: 30%">
                                            E-MAIL
                                        </td>
                                        <td class="fondoResaltado" style="width: 30%">
                                            TEL&Eacute;FONO
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            FAX
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            PATENTE PROFESIONAL N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="email_arq" name="email_arq" type="email" [(ngModel)]="arquitectos[0].mail" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="tel_arq" name="tel_arq" type="text" [(ngModel)]="arquitectos[0].fono" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fax_arq" name="fax_arq" type="text" [(ngModel)]="arquitectos[0].fax" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="pat_arq" name="pat_arq" type="text" [(ngModel)]="arquitectos[0].patente" />
                                        </td>
                                    </tr>
                                </table>
                                <span class="letraChica">NOTA: DE HABER MAS DE UN PROFESIONAL RESPONSABLE, ADJUNTAR DOCUMENTO CON FORMATO SIMILAR AL ANTERIOR QUE CONTENGA LOS DATOS NECESARIOS.</span>
                            </div>
                            <div class="tituloSeccion">
                                <span>3.- REVISOR INDEPENDIENTE</span><span> (si corresponde)</span>
                                <span class="help-block"></span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td style="width: 50%" class="fondoResaltado" align="left"><span>
                                                    CUENTA CON INFORME FAVORABLE DE REVISOR INDEPENDIENTE</span>
                                    </td>
                                    <td style="width: 7%" class="fondoResaltado"><span>N°</span></td>
                                    <td style="width: 15%">
                                        <span><input disabled class="form-control" readonly id="numero" name="numero" type="text" [(ngModel)]="informe[0].num_informe" *ngIf="informe[0].infradio == 'SI'" /></span>
                                        <span><input disabled class="form-control" readonly id="numero" name="numero" type="text" *ngIf="informe[0].infradio == 'NO'" /></span>
                                    </td>
                                    <td style="width:10%" class="fondoResaltado"><span>Fecha</span></td>
                                    <td style="width: 15%">
                                        <span><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" [(ngModel)]="informe[0].fech_informe" *ngIf="informe[0].infradio == 'SI'"/></span>
                                        <span><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" *ngIf="informe[0].infradio == 'NO'"/></span>
                                    </td>
                                </tr>
                            </table>
                            <table class="tablaConBorde2 table form-group">
                                <tr>
                                    <td class="fondoResaltado izquierda" style="width: 100%" colspan="5">
                                        NOMBRE DEL REVISOR INDEPENDIENTE
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="5">
                                        <input disabled class="form-control" readonly id="nombre_ind" name="nombre_ind" type="text" [(ngModel)]="independiente[0].nombre" *ngIf="informe[0].infradio == 'SI'" />
                                        <input disabled class="form-control" readonly id="nombre_ind" name="nombre_ind" type="text" *ngIf="informe[0].infradio == 'NO'" />
                                    </td>

                                </tr>
                                <tr class="fondoResaltado">
                                    <td class="fondoResaltado" style="width: 25%">
                                        R.U.T.
                                    </td>
                                    <td style="width: 25%">EMAIL</td>
                                    <td style="width: 25%">TELEFONO / FAX</td>
                                    <td style="width: 10%">CATEGORIA</td>
                                    <td style="width: 15%">REGISTRO</td>
                                </tr>
                                <tr>
                                    <td>
                                        <input disabled class="form-control" id="rut_ind" name="rut_ind" type="text" [(ngModel)]="independiente[0].rut" *ngIf="informe[0].infradio == 'SI'" />
                                        <input disabled class="form-control" id="rut_ind" name="rut_ind" type="text" *ngIf="informe[0].infradio == 'NO'" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="email_ind" name="email_ind" type="text" [(ngModel)]="independiente[0].mail" *ngIf="informe[0].infradio == 'SI'" />
                                        <input disabled class="form-control" readonly id="email_ind" name="email_ind" type="text" *ngIf="informe[0].infradio == 'NO'" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="telf_ind" name="telf_ind" type="text" [(ngModel)]="independiente[0].fono" *ngIf="informe[0].infradio == 'SI'" />
                                        <input disabled class="form-control" readonly id="telf_ind" name="telf_ind" type="text" *ngIf="informe[0].infradio == 'NO'" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="cat_ind" name="cat_ind" type="text" [(ngModel)]="independiente[0].categoria" *ngIf="informe[0].infradio == 'SI'" />
                                        <input disabled class="form-control" readonly id="cat_ind" name="cat_ind" type="text" *ngIf="informe[0].infradio == 'NO'" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="reg_ind" name="reg_ind" type="text" [(ngModel)]="independiente[0].registro" *ngIf="informe[0].infradio == 'SI'" />
                                        <input disabled class="form-control" readonly id="reg_ind" name="reg_ind" type="text" *ngIf="informe[0].infradio == 'NO'" />
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <br>
                        <br>
                        <br>
                        <br>
                        <div id='page2' class="contenedorFormulario print-wrap page2">
                            <div>
                                <span style="float: right; clear: right;">(S.R.D.E. - 5.2.5./5.2.6.)</span> Formulario 2.7
                                <span style="float: right; clear: right;">2/3</span>
                            </div>
                            <br />
                            <div>
                                <div class="tituloSeccion">
                                    <span>4.- PROFESIONALES COMPETENTES</span>
                                    <span class="help-block"></span>
                                </div>
                                <div>
                                    <table class="tablaConBorde table form-group clone1">
                                        <tr class="fondoResaltado">
                                            <td align="left" colspan="3">
                                                NOMBRE DEL <strong>CONSTRUCTOR</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                <input disabled class="form-control" id="cons_nombre" name="cons_nombre" type="text" [(ngModel)]="constructores[0].nombre" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="fondoResaltado">
                                                R.U.T.
                                            </td>
                                            <td class="fondoResaltado">
                                                E-MAIL
                                            </td>
                                            <td class="fondoResaltado">
                                                TELEFONO/FAX
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input disabled class="form-control" id="cons_rut" name="cons_rut" type="text" [(ngModel)]="constructores[0].rut" />
                                            </td>
                                            <td>
                                                <input disabled class="form-control" id="cons_email" name="cons_email" type="text" [(ngModel)]="constructores[0].mail" />
                                            </td>
                                            <td>
                                                <input disabled class="form-control" id="cons_fono" name="cons_fono" type="text" [(ngModel)]="constructores[0].fono" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                <input disabled class="form-control" id="vacio" name="vacio" type="text" />
                                            </td>
                                        </tr>
                                        <tr class="fondoResaltado">
                                            <td align="left" colspan="3">
                                                PROFESIONAL COMPETENTE QUE INFORMA MEDIDAS DE GESTION Y CONTROL DE CALIDAD <span class="letraChica"> (si corresponde)</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                <input disabled class="form-control" id="calc_nombre" name="calc_nombre" type="text" [(ngModel)]="profesionalComp[0].nombre" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="fondoResaltado">
                                                R.U.T.
                                            </td>
                                            <td class="fondoResaltado">
                                                E-MAIL
                                            </td>
                                            <td class="fondoResaltado">
                                                TELEFONO/FAX
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input disabled class="form-control" id="calc_rut" name="calc_rut" type="text" [(ngModel)]="profesionalComp[0].rut" />
                                            </td>
                                            <td>
                                                <input disabled class="form-control" id="calc_rut" name="calc_rut" type="text" [(ngModel)]="profesionalComp[0].mail" />
                                            </td>
                                            <td>
                                                <input disabled class="form-control" id="calc_rut" name="calc_rut" type="text" [(ngModel)]="profesionalComp[0].fono" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                <input disabled class="form-control" id="vacio" name="vacio" type="text" />
                                            </td>
                                        </tr>
                                        <tr class="fondoResaltado">
                                            <td align="left" colspan="3">
                                                INSPECTOR TECNICO DE LA OBRA (ITO) <span class="letraChica"> (si corresponde)</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                <input disabled class="form-control" id="rep_nombre" name="rep_nombre" type="text" [(ngModel)]="inspectorObra[0].nombre" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="fondoResaltado">
                                                RUT
                                            </td>
                                            <td class="fondoResaltado">
                                                E-MAIL
                                            </td>
                                            <td class="fondoResaltado">
                                                TELEFONO/FAX
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input disabled class="form-control" id="rep_nombre" name="rep_nombre" type="text" [(ngModel)]="inspectorObra[0].rut" />
                                            </td>
                                            <td>
                                                <input disabled class="form-control" id="rep_nombre" name="rep_nombre" type="text" [(ngModel)]="inspectorObra[0].mail" />
                                            </td>
                                            <td>
                                                <input disabled class="form-control" id="rep_nombre" name="rep_nombre" type="text" [(ngModel)]="inspectorObra[0].fono" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                <input disabled class="form-control" id="vacio" name="vacio" type="text" />
                                            </td>
                                        </tr>
                                    </table>

                                </div>
                            </div>
                            <div class="tituloSeccion">
                                <span>5.- TIPO DE PROYECTO:</span>
                                <span class="help-block"></span>
                            </div>
                            <div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr>
                                        <td style="width: 3%" align="center"><input disabled class="form-check-inline" type="checkbox" name="tipo_proyecto" id="tipo_proyecto" [checked]="tipo_proyecto[0].tipo_proy1" align="left" /></td>
                                        <td style="width: 47%" colspan="3">CONDOMINIO TIPO A</td>
                                        <td style="width: 3%" align="center"><input disabled class="form-check-inline" type="checkbox" name="tipo_proyecto" id="tipo_proyecto" [checked]="tipo_proyecto[0].tipo_proy2 == '1'" align="left" /></td>
                                        <td style="width: 47%" colspan="3">CONDOMINIO TIPO B</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 3% ; padding-top: 8px" align="center"><input disabled class="form-check-inline" type="checkbox" name="tipo_proyecto" id="tipo_proyecto" [checked]="tipo_proyecto[0].tipo_proy3" align="left" /></td>
                                        <td>EDIFICACIONES EN LOTEO CON <br>CONSTRUCCI&Oacute;N SIMULTANEA</td>
                                        <td style="width: 3% ; padding-top: 8px" align="center"><input disabled class="form-check-inline" type="checkbox" name="tipo_proyecto" id="tipo_proyecto" [checked]="tipo_proyecto[0].tipo_proy4" align="left" /></td>
                                        <td style="padding-top: 10px">URBANIZACI&Oacute;N RECIBIDA</td>
                                        <td style="width: 3% ; padding-top: 8px" align="center"><input disabled class="form-check-inline" type="checkbox" name="tipo_proyecto" id="tipo_proyecto" [checked]="tipo_proyecto[0].tipo_proy5" align="left" /></td>
                                        <td style="padding-top: 10px">URBANIZACI&Oacute;N GARANTIZADA</td>
                                        <td style="width: 3% ; padding-top: 8px" align="center"><input disabled class="form-check-inline" type="checkbox" name="tipo_proyecto" id="tipo_proyecto" [checked]="tipo_proyecto[0].tipo_proy6" align="left" /></td>
                                        <td>RECEPCI&Oacute;N DE URBANIZACI&Oacute;N <br>SOLICITADA CONJUNTAMENTE</td>
                                    </tr>
                                </table>
                            </div>
                            <br>
                            <div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="fondoResaltado">
                                        <td align="left" style="width: 40%">
                                            PERMISO PARA EL QUE SOLICITA ESTA RECEPCI&Oacute;N
                                        </td>
                                        <td align="center">
                                            NUMERO
                                        </td>
                                        <td align="center">
                                            FECHA
                                        </td>
                                        <td align="center">
                                            SUPERFICIE m2
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input disabled class="form-control" id="perm_recep" name="perm_recep" type="text" [(ngModel)]="tipo_proyecto[0].perm_recep" /></td>
                                        <td><input disabled class="form-control" id="perm_numero" name="perm_numero" type="text" [(ngModel)]="tipo_proyecto[0].perm_numero" /></td>
                                        <td><input disabled class="form-control" id="perm_fecha" name="perm_fecha" type="text" [(ngModel)]="tipo_proyecto[0].perm_fecha" /></td>
                                        <td><input disabled class="form-control" id="perm_sup" name="perm_sup" type="text" [(ngModel)]="tipo_proyecto[0].perm_sup" /></td>
                                    </tr>
                                    <br>
                                    <tr>
                                        <td class="fondoResaltado" align="left">
                                            MODIFICACI&Oacute;N DE PROYECTO. RESOLUCION Nº
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="mod_proy_res" name="mod_proy_res" type="text" [(ngModel)]="tipo_proyecto[0].mod_proy_res" />
                                        </td>
                                        <td class="fondoResaltado">
                                            FECHA
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="mod_proy_fech" name="mod_proy_fech" type="text" [(ngModel)]="tipo_proyecto[0].mod_proy_fech" />
                                        </td>
                                    </tr>
                                </table>
                                <br>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr>
                                        <td class="fondoResaltado" align="left">
                                            RECEPCI&Oacute;N PARCIAL
                                        </td>
                                        <td style="width: 5%" align="center">
                                            <span>SI </span><input disabled class="form-check-inline" type="checkbox" name="rparcial_proy_res" id="rparcial_proy_res" [checked]="tipo_proyecto[0].rparcial_proy_res == 'SI'" align="left" />
                                        </td>
                                        <td style="width: 5%" align="center">
                                            <span>NO </span><input disabled class="form-check-inline" type="checkbox" name="rparcial_proy_res" id="rparcial_proy_res" [checked]="tipo_proyecto[0].rparcial_proy_res == 'NO'" align="left" />
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            SUPERFICIE
                                        </td>
                                        <td class="fondoResaltado">
                                            DESTINO (S)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado" colspan="3" style="width: 40%" align="left">
                                            PARTE A RECEPCIONAR
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="sup_proy_res" name="sup_proy_res" type="text" [(ngModel)]="tipo_proyecto[0].sup_proy_res" *ngIf="tipo_proyecto[0].rparcial_proy_res == 'SI'" />
                                            <input disabled class="form-control" id="sup_proy_res" name="sup_proy_res" type="text" *ngIf="tipo_proyecto[0].rparcial_proy_res == 'NO'" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="dest_proy_res" name="dest_proy_res" type="text" [(ngModel)]="tipo_proyecto[0].dest_proy_res" *ngIf="tipo_proyecto[0].rparcial_proy_res == 'SI'" />
                                            <input disabled class="form-control" id="dest_proy_res" name="dest_proy_res" type="text" *ngIf="tipo_proyecto[0].rparcial_proy_res == 'NO'" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div class="tituloSeccion">
                                <span>6.- PERMISOS Y RECEPCIONES ANTERIORES</span>
                                <span class="help-block"></span>
                            </div>
                            <div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="fondoResaltado">
                                        <td style="width: 25%">
                                            PERMISO DE
                                        </td>
                                        <td style="width: 10%">
                                            NUMERO
                                        </td>
                                        <td style="width: 15%">
                                            FECHA
                                        </td>
                                        <td style="width: 15%">
                                            SUP. M2
                                        </td>
                                        <td style="width: 20%">
                                            CERT. RECEPCI&Oacute;N
                                        </td>
                                        <td style="width: 15%">
                                            FECHA
                                        </td>
                                    </tr>
                                    <tr *ngFor="let perm of perm">
                                        <td>
                                            <input disabled class="form-control" id="permiso" name="permiso" type="text" [(ngModel)]="perm.permiso" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="perm.numero" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fecha" name="fecha" type="text" [(ngModel)]="perm.fecha" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="superficie" name="superficie" type="text" [(ngModel)]="perm.superficie" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="recepcion" name="recepcion" type="text" [(ngModel)]="perm.recepcion" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fecha_recep" name="fecha_recep" type="text" [(ngModel)]="perm.fecha_recep" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div class="tituloSeccion">
                                <span>7.- ANTECEDENTES QUE SE ADJUNTAN</span>
                                <span class="help-block"></span>
                            </div>
                            <div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td style="width: 5%">DOM</td>
                                        <td colspan="2" align="left">DOCUMENTOS</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos"  checked disabled/></td>
                                        <td><span>Informe de arquitecto que cartifique que las obras se han ejecutado conforme al permiso aprobado, incluidas sus modificaciones</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Informe del Inspector T&eacute;cnico de Obras, si corresponde, que señale que las obras se ejecutaron conforme a las normas de construcci&oacute;n aplicables al permiso aprobado</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Informe de la empresa, el constructor u otro profesional seg&uacute;n corresponda, en que se detalle las medidas de gesti&oacute;n y control de calidad adoptadas en la obra</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Informe del Revisor Independiente</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Resolucion de calificaci&oacute;n ambiental del proyecto, cuando proceda. Ley 19.300</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Libro de Obra</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Fotocopia de la patente municipal al d&iacute;a del arquitecto y dem&aacute;s profesionales que concurren en la solicitud</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td><span>Certificado vigente de inscripci&oacute;n del Revisor Independiente, cuando proceda</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Comprobante Total de Pago de Derechos Municipales en caso de haber convenio de pago</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td><span>Otros</span></td>
                                    </tr>
                                </table>
                            </div>
                            <br>
                            <div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td style="width: 5%">DOM</td>
                                        <td colspan="6" align="left">CERTIFICADOS</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td style="width: 39%"><span>Certificado de dotaci&oacute;n de agua potable y alcantarillado emitido por la empresa de Servicios Sanitarios o por la Autoridad Sanitaria, seg&uacute;n corresponda</span></td>
                                        <td style="width: 22%"></td>
                                        <td></td>
                                        <td style="width: 7%"></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td><span>Documentos a que se refieren los art. 5.9.2 y 5.9.3 de la OGUC de instalaciones el&eacute;ctricas inferiores e instalaciones inferiores de gas, cuando proceda</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Declaraci&oacute;n de instalaciones el&eacute;ctricas de ascensores y montacargas</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Certificado del fabricante instalador de ascensores</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td><span>Declaraci&oacute;n de instalaciones de calefacci&oacute;n, central de agua caliente y aire acondicionado, emitida por el instalador, cuando proceda</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td><span>Certificados de ensaye de los hormigones empleados en la obra, cuando proceda</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Certificado que señale la reposici&oacute;n de los pavimentos y obras de ornato existentes con anterioridad al otorgamientoo del permiso, en el espacio publico que enfrenta el previo</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </table>
                            </div>
                            <br>
                            <div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td style="width: 5%">DOM</td>
                                        <td colspan="2" align="left">Planos</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Planos correspondientes a las redes y elemnetos de Telecomunicaciones</span></td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <br>
                        <br>
                        <div id='page3' class="contenedorFormulario print-wrap page3">
                            <div style="margin-bottom: 30px">
                                <span style="float: right; clear: right;">(S.R.D.E. - 5.2.5./5.2.6.)</span> <span>Formulario 2.7</span>
                                <span style="float: right; clear: right;">3/3</span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td class="fondoResaltado" colspan="2" style="height: 20px;">
                                        <strong>LISTADO DE PLANOS QUE SE REEMPLAZAN, SE AGREGAN O ELIMINAN</strong> <span> (Art.5.2.8 OGUC)</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="height: 20px; width: 15%" align="center">
                                        PLANO Nº
                                    </td>
                                    <td align="tablaConBordeExterno">
                                        CONTENIDO
                                    </td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                            </table>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br />
                            <br />
                            <br />
                            <br />
                            <hr>
                            <div class="col-md-3"></div>
                            <div style="padding-left: 72px" class="col-md-6">
                                <h1><strong>COMPROBANTE DE INGRESO</strong></h1>
                                <span style="float: right; clear: right;">(S.R.D.E. - 5.2.5./5.2.6.)</span>
                            </div>
                            <div class="col-md-12 tituloSeccion" align="center">
                                <span>SOLICITUD DE RECEPCI&Oacute;N DEFINITVA DE OBRAS DE EDIFICACI&Oacute;N</span>
                                <span class="help-block"></span>
                            </div>

                            <br>
                            <br />
                            <br />
                            <br />
                            <div class="row">
                                <div class="col-md-3">
                                    <table class="tablaConBordeExterno">
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr align="center">
                                            <td>FIRMA FUNCIONARIO.</td>
                                        </tr>
                                        <tr align="center">
                                            <td> Y TIMBRE D.O.M.</td>
                                        </tr>

                                    </table>

                                </div>
                                <br />
                                <div class="col-md-1"></div>
                                <div class="col-md-4">
                                    <h2 class="infObligatorios">
                                        <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                    <h2 class="infObligatorios"> {{region}} </h2>
                                </div>
                                <div class="col-md-4">
                                    <table style="float: right; clear: right; width: 64%;" class="tablaConBorde table">
                                        <tbody>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    N&Uacute;MERO SOLICITUD
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">
                                                    <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center" class="fondoResaltado" style="width: 20%">
                                                    Fecha de Ingreso
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                            <br />
                            <div>
                                <table class="tablaConBorde">
                                    <tr class="fondoResaltado">
                                        <td style="width: 80%">CALLE O CAMINO</td>
                                        <td>N&Uacute;MERO</td>
                                    </tr>
                                    <tr>
                                        <td><input class="form-control" type="text" id="calle" name="calle" disabled [(ngModel)]="propiedad[0].calle" /></td>
                                        <td><input class="form-control" type="text" id="numero" name="numero" disabled [(ngModel)]="propiedad[0].calle_num" /></td>
                                    </tr>
                                </table>
                            </div>
                            <hr />
                            <br />
                            <br />
                            <br />
                            <br />

                            <br />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12" align="left">
                <button mat-raised-button color="primary" id="pdf-download-link" title="Descargar Formulario 2.7" (click)="captureScreen()">Descargar Formulario 2.7</button>
            </div>
        </fieldset>
    </div>
</div>